// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13Znk","newExpiryDate":"styles_newExpiryDate__OKu5f","footer":"styles_footer__2RTF1"};